var m = require('mithril');
var prop = require('mithril/stream');
var R = require('ramda');
var io = require('../libs/socketio');
var loaders = require('../layout/components/loaders');
var header = require('../layout/components/header');
var alarmMonitor = require('../layout/components/alarmMonitor');
var button = require('../components/button');
var heading = require('../components/heading');
var pointIncidentBrowse = require('./pointIncidentBrowse');

var event = {};

var trippedOrPendingReset = R.flip(R.contains)(['Alarm Tripped', 'Pending Alarm Reset']); //bool
var isActive = R.propSatisfies(trippedOrPendingReset, 'alarmStatus'); //bool
var isInactive = R.complement(isActive);
var isAcknowledged = R.propEq('acknowledged', 1);
var isUnacknowledged = R.complement(isAcknowledged);
var isActiveOrUnacknowledged = R.either(isActive, isUnacknowledged);
var sortDateDescending = R.sort((a,b) => b.lastTripTimestamp - a.lastTripTimestamp);

event.oninit = function () {
  document.title = 'nimrod | Alarms';
  header.vm.activeTab('Alarms');
  m.redraw();
  var ctrl = this;
  ctrl.events = prop([]);

  ctrl.getEvents = function () {
    ctrl.sortedEvents =[];
    m.redraw();
    return Promise.resolve(alarmMonitor.getEvents())
    .then(function (response) {
      ctrl.events(Array.isArray(response) ? response : []);
      ctrl.sortAndFilter();
    });
  };

  ctrl.sortAndFilter = function () {
    var events = Array.isArray(ctrl.events()) ? ctrl.events() : [];
    ctrl.sortedEvents = events;
    if (ctrl.viewActiveOnly()) {
      ctrl.sortedEvents = sortDateDescending(R.filter(isActiveOrUnacknowledged)(events));
    } else {
      ctrl.sortedEvents = events;
    }
    m.redraw();
  }

  ctrl.sortedEvents = [];

  ctrl.toggleActiveFilter = function () {
    ctrl.sortedEvents = [];
    m.redraw();
    ctrl.viewActiveOnly(!ctrl.viewActiveOnly());
    ctrl.sortAndFilter();
  }
  ctrl.viewActiveOnly = prop(true);

  ctrl.ackAll = function () {
    loaders.requestWithLoader({
      url: '/api/v1/incident/ackandclear/',
      method: 'GET',
    })
    .then(() => {
      ctrl.getEvents();
    });
  };

  ctrl.ackEvent = function (incidentRid) {
    return loaders.requestWithLoader({
      url: '/api/v1/incident/' + incidentRid.slice(1) + '/acknowledge',
      method: 'PUT'
    })
    .then(() => ctrl.getEvents());
  };
  
  ctrl.handleAlarmUpdate = function (updatedIncident) {
    return ctrl.getEvents();
  }

  io.on('alarm-update', ctrl.handleAlarmUpdate);

  // Load alarms on initial page visit so the list renders.
  ctrl.getEvents().catch(function (error) {
    console.error('Failed to load alarms', error);
  });
};

event.onremove = function () {
  io.off('alarm-update', this.handleAlarmUpdate);
}
// View

event.view = function () {
  var ctrl = this;
  if (typeof ctrl.events !== 'function') {
    ctrl.events = prop([]);
  }
  if(alarmMonitor.events.length > 0){
    ctrl.events(alarmMonitor.events);
    if (typeof ctrl.sortAndFilter === 'function') {
      ctrl.sortAndFilter();
    }
  }else{
    m.redraw();
  }
  return m('div', [
    m('div', { class: 'container' }, [
      m(heading, { label: 'Alarms', class: 'f-subheadline mb3 pb1 display' }),
      m('div.flex.justify-between', [
        m(button, { class: 'link mb2 ' /*+ (ctrl.viewActiveOnly() ? '' : 'bg-gray')*/ , func: ctrl.toggleActiveFilter, label: 'Browse Inactive' }),
        m(button, { class: 'link mb2', func: ctrl.ackAll, label: 'Acknowledge All' }),
      ]),
      m('div',  (Array.isArray(ctrl.sortedEvents) ? ctrl.sortedEvents : []).map(function (evm) {
        return m(pointIncidentBrowse, {pointRecord:evm, parentCtrl:ctrl, key:evm['@rid']});
      }))
    ])
  ]);
};

module.exports = event;
